import React from 'react';
import { Accent, accentText } from '../lib/accents';

export const StatCard: React.FC<{ value: string; label: string; accent?: Accent }> = ({
    value,
    label,
    accent = 'primary',
}) => (
    <div className="text-center">
        <p className={`text-4xl md:text-5xl font-bold ${accentText[accent]}`}>{value}</p>
        <p className="text-muted-foreground mt-1 tracking-wider uppercase text-sm">{label}</p>
    </div>
);
